import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Below Target' },
    { value: 1, label: 'At Target' },
    { value: 2, label: 'Beyond Target' },
    { value: 3, label: 'Total At and Beyond' },
    { value: 4, label: 'Not Included' },
  ],
});
